module.exports = __webpack_public_path__ + "img/achievement-course2.018eed8a.png";